let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6k6Qj")).then(() => parcelRequire('9np4J'));